import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const defaultShowMessage = {
  title: "Message",
  message: "This is a message...",
  subMessage: null,
  buttons: {
    ok: {
      label: "OK",
      visible: true,
      onClick: () => { }, // eslint-disable-line
    },
    cancel: {
      label: "Cancelar",
      visible: false,
      onClick: () => { }, // eslint-disable-line
    },
  },
  open: false,
};

export default new Vuex.Store({
  state: {
    loginData: {
      id: localStorage.getItem("cnpj"),
      nome: localStorage.getItem("nome"),
      senha: localStorage.getItem("senha"),
      cnpj: localStorage.getItem("cnpj")
    },
    showMessage: defaultShowMessage,
    pedido: {
      data: '',
      cliente: {
        nomeRazaoSocial: 'CONSUMIDOR',
        cpfCnpj: '111.111.111-11',
        municipio: [
          {
            nome: '',
            microrregiao: {
              mesorregiao: {
                UF: {
                  nome: ''
                }
              }
            }
          }
        ],
      },
      produtos: [],
      quantidade: 0,
      vendedor: '',
      forma_pagamento: '',
      taxa_percentual: 0,
      taxa_valor: 0,
      desconto_percentual: 0,
      desconto_valor: 0,
      valor_liquido: 0,
      valor_bruto: 0,
      sincronizado: 0,
      cancelado: 0,
    },
    
  },
  mutations: {
    setLoginData(state, payload) {
      state.loginData = { ...payload };
    },
    showShowMessage(state, config) {
      state.showMessage = {
        ...defaultShowMessage,
        ...config,
        buttons: {
          ok: {
            ...(config.buttons.ok ? {
              ...config.buttons.ok, visible: !!config.buttons.ok, onClick: () => {
                state.showMessage.open = false;
                config.buttons.ok.onClick && config.buttons.ok.onClick();
              }
            } : {})
          },
          cancel: {
            ...(config.buttons.cancel ? {
              ...config.buttons.cancel, visible: !!config.buttons.cancel, onClick: () => {
                state.showMessage.open = false;
                config.buttons.cancel.onClick && config.buttons.cancel.onClick();
              }
            } : {})
          }
        },
        open: true
      }
    },
    closeShowMessage(state) {
      state.showMessage.open = false;
    },
    ZERARPEDIDO (state) {
      state.pedido = {
        data: '',
        cliente: {
          nomeRazaoSocial: 'CONSUMIDOR',
          cpfCnpj: '111.111.111-11',
          municipio: [
            {
              nome: '',
              microrregiao: {
                mesorregiao: {
                  UF: {
                    nome: ''
                  }
                }
              }
            }
          ],
        },
        produtos: [],
        quantidade: 0,
        vendedor: '',
        forma_pagamento: '',
        taxa_percentual: 0,
        taxa_valor: 0,
        desconto_percentual: 0,
        desconto_valor: 0,
        valor_liquido: 0,
        valor_bruto: 0,
        sincronizado: 0,
        cancelado: 0
      };
    },
    SETARPEDIDO (state, pedido) {
      state.pedido = pedido;
    }
  },
  actions: {},
  modules: {},
});
